(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["karevia-routine-quiz"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeQuiz = (quiz) => {
      if (quiz.dataset.initialized === 'true') return;
      quiz.dataset.initialized = 'true';

      const intro = quiz.querySelector('.karevia-quiz__intro');
      const form = quiz.querySelector('.karevia-quiz__form');
      const result = quiz.querySelector('.karevia-quiz__result');
      const steps = [...quiz.querySelectorAll('.karevia-quiz__step')];
      const start = quiz.querySelector('.karevia-quiz__start');
      const next = quiz.querySelector('.karevia-quiz__next');
      const back = quiz.querySelector('.karevia-quiz__back');
      const restart = quiz.querySelector('.karevia-quiz__restart');
      const error = quiz.querySelector('.karevia-quiz__error');
      const progressText = quiz.querySelector('.karevia-quiz__progress-text');
      const progressBar = quiz.querySelector('.karevia-quiz__bar');
      let current = 0;

      const urls = {
        volume: quiz.dataset.volumeUrl,
        hydration: quiz.dataset.hydrationUrl,
        nutrition: quiz.dataset.maskUrl,
        scalp: quiz.dataset.scrubUrl,
        oil: quiz.dataset.oilUrl
      };

      const showStep = (index) => {
        current = index;
        steps.forEach((step, stepIndex) => { step.hidden = stepIndex !== index; });
        back.hidden = index === 0;
        next.textContent = index === steps.length - 1 ? 'Voir ma routine' : 'Continuer';
        progressText.textContent = `Question ${index + 1} sur ${steps.length}`;
        progressBar.style.width = `${((index + 1) / steps.length) * 100}%`;
        error.hidden = true;
        steps[index].querySelector('legend').focus?.();
      };

      const checkedValues = (name) => [...form.querySelectorAll(`input[name="${name}"]:checked`)].map((input) => input.value);
      const oneValue = (name) => checkedValues(name)[0] || '';

      const validStep = () => {
        const inputs = [...steps[current].querySelectorAll('input')];
        return inputs.some((input) => input.checked);
      };

      const addExtra = (container, title, copy, url) => {
        const card = document.createElement('div');
        card.className = 'karevia-quiz__extra-card';
        const heading = document.createElement('strong');
        heading.textContent = title;
        const text = document.createElement('span');
        text.textContent = copy + ' ';
        card.append(heading, text);
        if (url) {
          const link = document.createElement('a');
          link.href = url;
          link.textContent = 'Découvrir ce soin';
          card.append(link);
        }
        container.append(card);
      };

      const calculate = () => {
        const score = { volume: 0, hydration: 0, nutrition: 0, scalp: 0 };
        const priority = oneValue('priority');
        if (score[priority] !== undefined) score[priority] += 3;

        const hairStates = checkedValues('hair_state');
        hairStates.forEach((value) => {
          if (score[value] !== undefined) score[value] += 1;
          if (value === 'shine' || value === 'detangle') score.hydration += 1;
        });

        const scalp = oneValue('scalp');
        if (['oily', 'buildup', 'freshness'].includes(scalp)) score.scalp += 2;
        if (scalp === 'sensitive') score.scalp += 1;

        const styling = checkedValues('styling');
        if (styling.some((value) => ['gel', 'oils', 'fixing'].includes(value))) score.scalp += 2;

        const lengths = oneValue('lengths');
        if (score[lengths] !== undefined) score[lengths] += 2;
        if (lengths === 'shine') score.hydration += 2;

        const nonScalp = ['volume', 'hydration', 'nutrition'];
        let main = nonScalp.sort((a, b) => score[b] - score[a])[0];
        if (score.scalp >= 4 && score[main] <= 1) main = 'scalp';

        const content = {
          volume: {
            title: 'Votre priorité : le volume et la densité visuelle',
            text: 'Vos réponses indiquent que vos cheveux paraissent fins, plats ou en manque de matière. La Routine Volume KARÉVIA vous aide à construire un rituel cohérent, du cuir chevelu jusqu’aux longueurs.',
            label: 'Découvrir la Routine Volume'
          },
          hydration: {
            title: 'Votre priorité : l’hydratation et la douceur',
            text: 'Vos réponses indiquent que vos cheveux semblent secs, ternes ou déshydratés. Le Duo Hydratation & Nutrition KARÉVIA accompagne les longueurs qui ont besoin de douceur, de souplesse et de brillance.',
            label: 'Découvrir le Duo Hydratation & Nutrition'
          },
          nutrition: {
            title: 'Votre priorité : le soin des longueurs fragilisées',
            text: 'Vos réponses indiquent que vos longueurs ont besoin d’un soin plus intensif. Le Masque Réparateur & Nutrition KARÉVIA aide à améliorer leur douceur, leur souplesse et leur apparence.',
            label: 'Découvrir le Masque Réparateur & Nutrition'
          },
          scalp: {
            title: 'Votre priorité : un cuir chevelu mieux débarrassé des accumulations',
            text: 'Vos réponses indiquent un besoin de nettoyage ciblé. Le Gommage Purifiant Romarin & Menthe peut être intégré occasionnellement avant le shampoing. Il ne remplace pas le shampoing et ne s’utilise pas à chaque lavage.',
            label: 'Découvrir le Gommage Purifiant'
          }
        };

        const selected = content[main];
        quiz.querySelector('.karevia-quiz__result-title').textContent = selected.title;
        quiz.querySelector('.karevia-quiz__result-text').textContent = selected.text;
        const primary = quiz.querySelector('.karevia-quiz__primary-link');
        primary.textContent = selected.label;
        primary.href = urls[main] || '#';

        const medical = quiz.querySelector('.karevia-quiz__medical');
        medical.hidden = oneValue('hair_loss') !== 'yes';

        const extraWrap = quiz.querySelector('.karevia-quiz__extras');
        const extraList = quiz.querySelector('.karevia-quiz__extra-list');
        extraList.replaceChildren();

        if (main !== 'scalp' && score.scalp >= 3) {
          addExtra(extraList, 'Gommage Purifiant du Cuir Chevelu', 'À utiliser occasionnellement lorsque le cuir chevelu semble encombré ou présente des accumulations.', urls.scalp);
        }
        const needsOil = hairStates.includes('shine') || hairStates.includes('hydration') || lengths === 'shine' || lengths === 'hydration' || lengths === 'nutrition';
        if (needsOil && main !== 'scalp') {
          addExtra(extraList, 'Huile Nourrissante au Romarin', 'À intégrer en complément lorsque les longueurs ont besoin de nutrition, de souplesse ou de brillance.', urls.oil);
        }
        extraWrap.hidden = extraList.children.length === 0;

        form.hidden = true;
        result.hidden = false;
        result.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      start.addEventListener('click', () => {
        intro.hidden = true;
        form.hidden = false;
        showStep(0);
      });

      next.addEventListener('click', () => {
        if (!validStep()) {
          error.hidden = false;
          return;
        }
        if (current < steps.length - 1) showStep(current + 1);
        else calculate();
      });

      back.addEventListener('click', () => { if (current > 0) showStep(current - 1); });

      restart.addEventListener('click', () => {
        form.reset();
        result.hidden = true;
        intro.hidden = false;
        current = 0;
        intro.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    };

    document.querySelectorAll('.karevia-quiz').forEach(initializeQuiz);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('.karevia-quiz').forEach(initializeQuiz);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
